export default (el, callback) => {
  let startX = false;
  let endX = false;

  function touchstart(event) {
    startX =
      event.type.indexOf('touch') > -1 ? event.touches[0].pageX : event.pageX;
    endX = false;
  }

  function touchmove(event) {
    if (startX === false) {
      return;
    }

    endX =
      event.type.indexOf('touch') > -1 ? event.touches[0].pageX : event.pageX;
  }

  function touchend() {
    if (endX !== false && startX !== false) {
      const distance = Math.abs(startX - endX);

      if (distance > 40) {
        callback(startX < endX ? 'right' : 'left');
      }
    }

    startX = false;
    endX = false;
  }

  el.addEventListener('dragstart', event => {
    event.preventDefault();
  });

  ['touchstart', 'mousedown'].forEach(ev => {
    el.addEventListener(ev, touchstart);
  });

  ['touchmove', 'mousemove'].forEach(ev => {
    el.addEventListener(ev, touchmove);
  });

  ['touchend', 'mouseup'].forEach(ev => {
    el.addEventListener(ev, touchend);
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/swipe.js